export type FilterObject = { [key: string]: string | string[] };

export const reduceFiltersToApi = (filters: FilterObject) => {
  return Object.keys(filters).reduce((acc: FilterObject, filter: string) => {
    if (filters[filter] && filters[filter].length) {
      acc[filter] = filter.includes("After")
        ? new Date(`${filters[filter]}T00:00:00`).toISOString()
        : filter.includes("Before")
        ? new Date(`${filters[filter]}T23:59:59`).toISOString()
        : filters[filter];
    }
    return acc;
  }, {});
};

export const reduceFiltersForSearchParams = (filters: FilterObject) => {
  return Object.keys(filters).reduce((acc: FilterObject, filter: string) => {
    if (filters[filter] && filters[filter].length) {
      acc[filter] = filters[filter];
    }
    return acc;
  }, {});
};

export const resetFilters = (filters: FilterObject) => {
  return Object.keys(filters).reduce(
    (results: FilterObject, filterKey: string) => {
      results[filterKey] = "";
      return results;
    },
    {}
  );
};

export const resetBooleanFilters = (filters: { [key: string]: boolean }) => {
  return Object.keys(filters).reduce(
    (results: { [key: string]: boolean }, key: string) => {
      results[key] = false;
      return results;
    },
    {}
  );
};
